import React from 'react';
import PropTypes from 'prop-types';

import { feeGroups } from '../../ducks';
import { duckify } from "utils/duckify";

import FeeGroupListItem from './FeeGroupListItem';

const FeeGroupListWrapper = ({ feeGroups }) => {
  /* get a list of the FeeGroupList Items to populate, pass them their relevant data */
  const groupFeeGroupListItem = feeGroups.map((data) => {
    return <FeeGroupListItem data={data} key={data.id} />
  })

  return (
    <React.Fragment>
      {groupFeeGroupListItem}
    </React.Fragment>
  )
}

const mapDucksToProps = () => ({ feeGroups });

FeeGroupListWrapper.propTypes = {
  feeGroups: PropTypes.array
};

export default duckify(mapDucksToProps)(FeeGroupListWrapper);